/** Paginated listing of the fabrics. */
import { infiniteQueryOptions } from '@tanstack/react-query';
import type { z } from 'zod';
import { api } from '@/shared/api/client';
import { dmsPageSchema, type AnyDmsData, type DmsPage } from '../api';

export interface FabricListParams {
  search: string;
  sortBy: string | null;
  sortOrder: 'asc' | 'desc';
  productLine: string | null;
  fabricBook: string | null;
  /** Bumped to reload from the first page. */
  refresh: number;
}

/** GET dms-item/fabrics: the fabrics, searched by code, sorted and filtered by the API. */
export const fabricPagesQueryOptions = <Data extends AnyDmsData>(
  {
    search,
    sortBy,
    sortOrder,
    productLine,
    fabricBook,
    refresh,
  }: FabricListParams,
  data: z.ZodType<Data>,
) =>
  infiniteQueryOptions({
    queryKey: [
      'dms-items',
      'fabric',
      'pages',
      { search, sortBy, sortOrder, productLine, fabricBook, refresh },
    ] as const,
    queryFn: ({ pageParam }) =>
      api.get<DmsPage<Data>>('dms-item/fabrics', {
        query: {
          sortOrder,
          ...(sortBy ? { sortBy } : {}),
          ...(search ? { search } : {}),
          ...(productLine ? { productLine } : {}),
          ...(fabricBook ? { fabricBook } : {}),
          ...(pageParam ? { after: pageParam } : {}),
        },
        schema: dmsPageSchema(data),
      }),
    initialPageParam: '' as string,
    getNextPageParam: (page) => page.nextCursor ?? undefined,
    retry: false,
  });
